import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInterceptor from 'src/app/axiosInterceptor';
import { _convertObjectToQuery } from 'src/app/utils/apiService';
import { showGlobalToast } from 'src/features/uiSlice';
import { messageToastType_const } from 'src/app/constant/config';

export const getOrderReceipts = createAsyncThunk(
  'orderReceiptSlice/getOrderReceipts',
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = _convertObjectToQuery(params);
      const response = await axiosInterceptor.get(`/order-receipt?${query}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const exportOrderReceiptsExcel = createAsyncThunk(
  'orderReceiptSlice/exportOrderReceiptsExcel',
  async (params = {}, { dispatch, rejectWithValue }) => {
    try {
      const query = _convertObjectToQuery(params);
      const response = await axiosInterceptor.get(`/order-receipt/export/excel?${query}`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const fileName = `dong_tien_${new Date().toISOString().slice(0, 10)}.xlsx`;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      dispatch(
        showGlobalToast({
          message: 'Xuất file Excel dòng tiền thành công!',
          type: messageToastType_const.success
        })
      );
      return true;
    } catch (err) {
      const errMsg = err.response?.data?.message || 'Xuất file Excel thất bại!';
      dispatch(
        showGlobalToast({
          message: errMsg,
          type: messageToastType_const.error
        })
      );
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  transactions: [],
  total: 0,
  summary: {
    order_amount_sum: 0,
    order_paid_sum: 0,
    receipt_amount_sum: 0,
    total_cash_in: 0
  },
  loading: false,
  error: null
};

const orderReceiptSlice = createSlice({
  name: 'orderReceiptSlice',
  initialState,
  reducers: {
    clearOrderReceipts: (state) => {
      state.transactions = [];
      state.total = 0;
      state.summary = initialState.summary;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrderReceipts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrderReceipts.fulfilled, (state, action) => {
        state.loading = false;
        const resData = action.payload || {};
        const payload = resData.payload || resData;
        state.transactions = payload.transactions || (Array.isArray(payload) ? payload : (resData.transactions || []));
        state.total = resData.numberOfItem !== undefined
          ? resData.numberOfItem
          : (resData.total !== undefined
              ? resData.total
              : (payload.numberOfItem !== undefined ? payload.numberOfItem : (payload.total || 0)));
        state.summary = resData.summary || payload.summary || initialState.summary;
      })
      .addCase(getOrderReceipts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearOrderReceipts } = orderReceiptSlice.actions;
export default orderReceiptSlice.reducer;
